module.exports = __webpack_public_path__ + "2acb60f2/img/delete-icon.eb7de062.svg";